import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en.json';
import viTranslation from './locales/vi.json';
import { LANGUAGE } from '../constants';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      vi: {
        translation: viTranslation,
      },
    },
    lng: LANGUAGE.VN,
    fallbackLng: [LANGUAGE.EN],
    // fallbackLng: [LANGUAGE.EN, LANGUAGE.PH, LANGUAGE.TH, LANGUAGE.CN],
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: ':::',
    keySeparator: '::',
  });

export default i18n;
